export default __webpack_public_path__ + "static/media/hht2_ani_10.655eb0f0.png";